<template>
    <div class="visitor-page">
        <div class="visitor-page-head">
            <div class="visitor-page-head-item">
                <SupsisButton
                    @click="() => (currentPage = 'visitors')"
                    :ghost="currentPage !== 'visitors'"
                    :primary="currentPage === 'visitors'"
                >
                    Contacts
                </SupsisButton>
            </div>
            <div class="visitor-page-head-item">
                <SupsisButton
                    @click="() => (currentPage = 'banned-visitors')"
                    :ghost="currentPage !== 'banned-visitors'"
                    :primary="currentPage === 'banned-visitors'"
                >
                    Banned Contacts
                </SupsisButton>
            </div>
        </div>
        <div class="visitor-page-content">
            <div id="visitors" v-if="currentPage === 'visitors'">
                <div class="filter-sidebar" :class="[dropdown && 'closed']">
                    <div class="filter-sidebar-content">
                        <div class="filter-sidebar-group">
                            <div class="filter-sidebar-group-title">{{ $t("message.favorites") }}</div>
                            <div class="filter-sidebar-group-content">
                                <div class="favorite-items">
                                    <div
                                        class="favorite-item"
                                        v-for="fav of favFilters['page.contact-list'] || []"
                                        :key="fav._id"
                                        :class="{ selected: selectedFavFilter && selectedFavFilter._id === fav._id }"
                                    >
                                        <div class="favorite-item-content" @click="selectFavFilter(fav)">
                                            <div class="favorite-item-icon material-icons">star</div>
                                            <div class="favorite-item-text">{{ fav.name }}</div>
                                        </div>
                                        <SaveFilterModal
                                            :value="fav.name"
                                            @save="saveFilter($event, fav)"
                                            @delete="deleteFavFilter(fav.key, fav._id)"
                                        >
                                            <template>
                                                <div class="favorite-item-edit material-icons">edit</div>
                                            </template>
                                            <template #content> sa</template>
                                        </SaveFilterModal>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="filter-sidebar-group group-filters">
                            <div class="filter-sidebar-group-title">{{ $t("message.filters") }}</div>
                            <div class="filter-sidebar-group-content">
                                <div class="item" v-for="(filter, index) of filteredItems">
                                    <MiniFilterPreview
                                        :filters="filters"
                                        :filter="filter"
                                        @deleteFilter="deleteFilter(index)"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="filter-sidebar-footer">
                        <div class="filter-sidebar-control">
                            <Filters align="top" v-model="filteredItems" :items="filters">
                                <template #content>
                                    <div class="control-button">
                                        <div class="material-icons">filter_alt</div>
                                        <div>{{ $t("chatbotv2.addFilter") }}</div>
                                    </div>
                                </template>
                            </Filters>

                            <div class="control-button" v-if="filteredItems.length > 0" @click="clearFilters">
                                <div class="material-icons">filter_alt_off</div>
                                <div>{{ $t("chatbotv2.clearFilter") }}</div>
                            </div>
                        </div>
                        <div class="filter-sidebar-collapse" @click="dropdown = !dropdown">
                            <div class="information-text">{{ $t("message.showHide") }}</div>
                            <div class="material-icons" style="cursor: pointer">
                                {{ dropdown ? "keyboard_double_arrow_right" : "keyboard_double_arrow_left" }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="visitors-content">
                    <div>
                        <div class="tool-head">
                            <div class="left-side">
                                <div class="save-filter-bar">
                                    <div class="filter-title">
                                        {{ selectedFavFilter ? selectedFavFilter.name : $t("message.contactSearch") }}
                                    </div>
                                    <SaveFilterModal
                                        v-if="selectedFavFilter"
                                        :value="selectedFavFilter.name"
                                        @save="saveFilter($event, selectedFavFilter)"
                                        @delete="deleteFavFilter(selectedFavFilter.key, selectedFavFilter._id)"
                                    >
                                        <template>
                                            <a-icon type="star" theme="filled" />
                                        </template>
                                        <template #content> sa</template>
                                    </SaveFilterModal>
                                    <SaveFilterModal @save="saveFilter" v-else>
                                        <template>
                                            <a-icon type="star" />
                                        </template>
                                        <template #content> sa</template>
                                    </SaveFilterModal>
                                </div>
                                <a-input-search
                                    style="width: 100%"
                                    :placeholder="$t('message.typeSTToSearch')"
                                    v-model="searchText"
                                    @change="onSearch"
                                ></a-input-search>
                            </div>
                            <div class="right-side">
                                <a-popover placement="bottomRight" trigger="click">
                                    <template slot="content">
                                        <div v-for="col of allColumns">
                                            <a-checkbox v-model="col.enabled" @change="onChangeCol(col, $event)">
                                                {{ col.title }}
                                            </a-checkbox>
                                        </div>
                                    </template>
                                    <a-button class="flex-center-center">
                                        <div class="material-icons">app_registration</div>
                                    </a-button>
                                </a-popover>
                                <a-button class="flex-center-center" @click="paddingReset">
                                    <div class="material-icons">
                                        {{ paddingReseted ? "fullscreen" : "fullscreen_exit" }}
                                    </div>
                                </a-button>
                                <a-popover placement="bottomRight" trigger="click" overlayClassName="download-popover">
                                    <template slot="content">
                                        <div class="download-options">
                                            <div class="export-csv-visitor-page" @click="exportToCSV">
                                                <div class="material-icons">description</div>
                                                {{ $t("message.downloadThePage") }} (CSV)
                                            </div>
                                            <div
                                                class="export-csv-visitor-page"
                                                :class="{ disabled: visitorDownloding }"
                                                @click="downloadAll"
                                            >
                                                <div class="material-icons">download</div>
                                                {{ $t("message.downloadAllData") }} (XLSX)
                                            </div>

                                            <div
                                                class="export-csv-visitor-page"
                                                :class="{ disabled: visitorDownloding }"
                                                @click="showSaveAsCustomerGroupModal('whatsapp')"
                                            >
                                                <div class="material-icons">save</div>
                                                {{ $t("visitor.saveAsCustomerGroup") }} (Whatsapp)
                                            </div>

                                            <div
                                                class="export-csv-visitor-page"
                                                :class="{ disabled: visitorDownloding }"
                                                @click="showSaveAsCustomerGroupModal('email')"
                                            >
                                                <div class="material-icons">save</div>
                                                {{ $t("visitor.saveAsCustomerGroup") }} (Email)
                                            </div>
                                        </div>
                                    </template>
                                    <a-button class="flex-center-center" style="margin-right: 3px">
                                        <div class="material-icons">more_horiz</div>
                                    </a-button>
                                </a-popover>
                            </div>
                        </div>
                        <supsis-table
                            id="supsis-contacts-list"
                            :class="{ 'visitor-table': true, expended: paddingReseted }"
                            :columns="tableColumns"
                            :rows="visitors"
                            :options="tableOptions"
                            :bottom-pagination="true"
                            :pagination-cursor="paginationCursor"
                            @cursor-changed="paginationCursorChanged"
                        >
                            <template #emptyData>
                                <EmptyFilterResult :clear-filters="clearFilters" />
                            </template>
                        </supsis-table>
                    </div>
                </div>
                <Modal2
                    v-if="saveAsCustomerGroupModalVisible"
                    :title="
                        saveAsCustomerGroupModalVisible === 'whatsapp'
                            ? $t('message.saveAsWhatsappCustomerGroup')
                            : $t('message.saveAsEmailCustomerGroup')
                    "
                    @cancel="closeCustomerGroupModal"
                    @ok="saveCustomerGroup"
                >
                    <div class="custom-alert" v-if="saveAsCustomerGroupModalVisible === 'whatsapp'">
                        <div class="custom-alert-icon">
                            <span class="material-icons">info</span>
                        </div>
                        <div class="custom-alert-content">
                            <ul>
                                <li>{{ $t("visitor.filterResultMax5000") }}</li>
                                <li>{{ $t("visitor.onlyContactsPhoneNumber") }}</li>
                            </ul>
                        </div>
                    </div>
                    <a-input v-model="customerGroupName" :placeholder="$t('visitor.enterGroupName')"></a-input>
                </Modal2>
            </div>
            <BannedVisitors v-else-if="currentPage === 'banned-visitors'" />
        </div>
    </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";
import AppBreadCrumb from "../../../components/common/AppBreadCrumb";
import { log2 } from "../../../utils/log2";
import Filters from "./components/Filters.vue";
import MiniFilterPreview from "./components/MiniFilterPreview.vue";
import NoData from "./components/svg/NoData.vue";
import SupsisTable from "../../../components/SupsisTable";

import WhatsappIcon from "../Chatbot/pages/integrations/svg/WhatsappIcon.vue";
import SaveFilterModal from "./components/SaveFilterModal.vue";
import GroupCollapse from "../../../components/GroupCollapse.vue";
import StringUtils from "../../../utils/StringUtils";
import IconButton from "../Settings/components/IconButton.vue";
import _ from "lodash";
import { exportToCSV, isMaskContactInfo, maskContactInfo } from "../../../utils/utils";
import { deleteFilterByKey, getOrUpdateFilters } from "../../../utils/persistenceStorage";
import PlatformIconViewer from "../../../components/common/PlatformIconViewer.vue";
import { PERMISSION_TYPES } from "../../../language/permissionTypes";
import EmptyFilterResult from "../Chatbot/pages/archive/EmptyFilterResult.vue";
import Modal2 from "../../../components/common/Modal2.vue";
import WHATSAPP_API from "../../../api/whatsapp";
import { MAIL_API } from "../../../api/mail";
import SupsisButton from "../Settings/components/SupsisButton.vue";
import BannedVisitors from "../Settings/pages/chat/BannedVisitors.vue";

const log = log2("Visitors");

const visitorStorageVersion = "v2.0";
const visitorStorageId = `visitor-filters-${visitorStorageVersion}`;
const visitorStorage = getOrUpdateFilters(visitorStorageId);
deleteFilterByKey(visitorStorageId);

export default {
    name: "Visitors",
    components: {
        BannedVisitors,
        SupsisButton,
        IconButton,
        GroupCollapse,
        SaveFilterModal,
        WhatsappIcon,
        AppBreadCrumb,
        Filters,
        MiniFilterPreview,
        NoData,
        SupsisTable,
        PlatformIconViewer,
        EmptyFilterResult,
        Modal2,
    },
    props: {
        pickerMode: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            currentPage: "visitors",
            dropdown: false,
            filters: [
                {
                    type: "input",
                    name: this.$t("message.name"),
                    material_icons: "person",
                    multiple: false,
                    key: "fullname",
                    operators: true,
                    omitOperators: ["less_than", "less_or_equal", "greater_than", "greater_or_equal"],
                },
                {
                    type: "input",
                    name: this.$t("message.email"),
                    material_icons: "alternate_email",
                    multiple: false,
                    key: "email",
                    operators: true,
                    omitOperators: ["less_than", "less_or_equal", "greater_than", "greater_or_equal"],
                },
                {
                    type: "platform-selector",
                    name: this.$t("chatbotv2.attr.platform"),
                    material_icons: "ads_click",
                    multiple: true,
                    key: "platform",
                    operators: true,
                    defaultValue: ["whatsapp", "instagram", "messenger"],
                    omitOperators: ["less_than", "less_or_equal", "greater_than", "greater_or_equal"],
                },
                {
                    type: "date-select",
                    name: this.$t("chatbotv2.attr.last_seen"),
                    material_icons: "date_range",
                    multiple: false,
                    singleton: true,
                    key: "lastSeen",
                    omitOperators: ["less_than", "less_or_equal", "greater_than", "greater_or_equal"],
                },
                {
                    type: "date-select",
                    name: this.$t("message.firstSeen"),
                    material_icons: "date_range",
                    multiple: false,
                    singleton: true,
                    key: "firstSeen",
                    omitOperators: ["less_than", "less_or_equal", "greater_than", "greater_or_equal"],
                },
                {
                    type: "country-selector",
                    name: this.$t("message.country"),
                    material_icons: "location_on",
                    multiple: true,
                    key: "country",
                    operators: true,
                    omitOperators: ["less_than", "less_or_equal", "greater_than", "greater_or_equal"],
                },
                {
                    type: "city-selector",
                    name: this.$t("message.city"),
                    material_icons: "location_on",
                    multiple: false,
                    key: "city",
                    operators: true,
                    omitOperators: ["less_than", "less_or_equal", "greater_than", "greater_or_equal"],
                },
                {
                    type: "os-selector",
                    name: this.$t("message.os"),
                    material_icons: "settings_suggest",
                    multiple: false,
                    key: "os",
                    operators: true,
                    omitOperators: ["less_than", "less_or_equal", "greater_than", "greater_or_equal"],
                },
                {
                    type: "date-select",
                    name: this.$t("message.connectionDate"),
                    material_icons: "date_range",
                    multiple: false,
                    singleton: true,
                    key: "connectionTime",
                },
                {
                    type: "input",
                    name: this.$t("message.visitingPage"),
                    material_icons: "public",
                    multiple: false,
                    key: "visitingPage",
                    operators: true,
                    omitOperators: ["less_than", "less_or_equal", "greater_than", "greater_or_equal"],
                },
                {
                    type: "browser-selector",
                    name: this.$t("message.browser"),
                    material_icons: "computer",
                    multiple: false,
                    key: "browser",
                    operators: true,
                    omitOperators: ["less_than", "less_or_equal", "greater_than", "greater_or_equal"],
                },
            ],
            filteredItems: this.pickerMode
                ? []
                : (visitorStorage.selectedFavFilter?.length > 0 && visitorStorage.selectedFavFilter) ||
                  (visitorStorage.filters?.length > 0 && visitorStorage.filters) || [
                      {
                          key: "platform",
                          rule: "contains",
                          value: ["whatsapp", "instagram", "messenger"],
                      },
                      {
                          key: "connectionTime",
                          rule: "contains",
                          value: "last7",
                      },
                  ],
            filterAccordion: true,
            searchText: visitorStorage.query,
            visitors: [],
            staticColumns: [
                {
                    title: this.$t("message.name"),
                    field: "fullname",
                    key: "fullname",
                    width: 200,
                    align: "left",
                    renderBodyCell: ({ row }) => {
                        return <div v-tippy={{ content: row.fullname }}>{row.fullname}</div>;
                    },
                },
                {
                    title: this.$t("message.email"),
                    field: "email",
                    key: "email",
                    width: 200,
                    align: "left",
                    renderBodyCell: ({ row }) => {
                        return <div v-tippy={{ content: row.email }}>{row.email}</div>;
                    },
                },
                {
                    title: this.$t("message.phone"),
                    field: "phone",
                    key: "phone",
                    width: 200,
                    align: "left",
                    renderBodyCell: ({ row }) => {
                        return (
                            <div v-tippy={{ content: row.phone || row.whatsappNumber }}>
                                {row.phone || row.whatsappNumber}
                            </div>
                        );
                    },
                },
                {
                    title: this.$t("chatbotv2.attr.platform"),
                    field: "platform",
                    key: "platform",
                    width: 100,
                    align: "left",
                    renderBodyCell: ({ row }) => {
                        return (
                            <div v-tippy={{ content: row.platform[0].toUpperCase() + row.platform.slice(1) }}>
                                <PlatformIconViewer platform={row.platform} />
                            </div>
                        );
                    },
                },
                {
                    title: this.$t("chatbotv2.attr.last_seen"),
                    field: "_id",
                    key: "_id",
                    width: 200,
                    align: "left",
                    renderBodyCell: ({ row }) => {
                        const formatedDate = this.formatDate(row.connectionTime);
                        return <div v-tippy={{ content: formatedDate }}>{formatedDate}</div>;
                    },
                },
                {
                    title: this.$t("message.firstSeen"),
                    field: "createdAt",
                    key: "createdAt",
                    width: 200,
                    align: "left",
                    renderBodyCell: ({ row }) => {
                        const formatedDate = this.formatDate(row.createdAt);
                        return <div v-tippy={{ content: formatedDate }}>{formatedDate}</div>;
                    },
                },
                {
                    title: this.$t("message.country"),
                    field: "country",
                    key: "country",
                    width: 200,
                    align: "left",
                    renderBodyCell: ({ row }) => {
                        return <div v-tippy={{ content: row.country }}>{row.country}</div>;
                    },
                },
                {
                    title: this.$t("message.city"),
                    field: "city",
                    key: "city",
                    width: 200,
                    align: "left",
                    renderBodyCell: ({ row }) => {
                        return <div v-tippy={{ content: row.city }}>{row.city}</div>;
                    },
                },
                {
                    title: this.$t("message.os"),
                    field: "os",
                    key: "os",
                    width: 200,
                    align: "left",
                    renderBodyCell: ({ row }) => {
                        return <div v-tippy={{ content: row.os }}>{row.os}</div>;
                    },
                },
                {
                    title: this.$t("message.connectionDate"),
                    field: "connectionTime",
                    key: "connectionTime",
                    width: 200,
                    align: "left",
                    renderBodyCell: ({ row }) => {
                        const formatedDate = this.formatDate(row.connectionTime);
                        return <div v-tippy={{ content: formatedDate }}>{formatedDate}</div>;
                    },
                },
                {
                    title: this.$t("message.visitingPage"),
                    field: "visitingPage",
                    key: "visitingPage",
                    width: 200,
                    align: "left",
                    renderBodyCell: ({ row }) => {
                        return <div v-tippy={{ content: row.visitingPage }}>{row.visitingPage}</div>;
                    },
                },
                {
                    title: this.$t("message.browser"),
                    field: "browser",
                    key: "browser",
                    width: 200,
                    align: "left",
                    renderBodyCell: ({ row }) => {
                        return <div v-tippy={{ content: row.browser }}>{row.browser}</div>;
                    },
                },
                {
                    title: "Tags",
                    field: "tags",
                    key: "tags",
                    width: 200,
                    align: "left",
                    renderBodyCell: ({ row }) => {
                        return (
                            <div v-tippy={{ content: row.tags.map((tag) => tag.name).join(",") }}>
                                {row.tags.map((tag) => {
                                    return (
                                        <a-tag color={"#22272d"} key={tag.id}>
                                            {tag.name}
                                        </a-tag>
                                    );
                                })}
                            </div>
                        );
                    },
                },
            ],
            allColumns: [],
            columns: [],
            filterTimeout: null,
            paddingReseted: false,
            tableOptions: {
                rowStyleOption: {
                    stripe: true,
                },
                borderX: true,
                borderY: true,
                scrollWidth: 1130,
                virtualScrollOptions: { itemSize: 50, height: 500 },
                eventCustomOption: {
                    bodyRowEvents: ({ row, rowIndex }) => {
                        return {
                            dblclick: (event) => {
                                if (!this.visitorDetailPermission) {
                                    this.$message.error(this.$t("permissionErrors.visitorDetailRead"));
                                } else {
                                    this.addNewWindow({
                                        type: "show-visitor",
                                        title: `${row.fullname || "Visitor"} Profile`,
                                        payload: {
                                            visitorId: row._id,
                                        },
                                    });
                                }
                            },
                        };
                    },
                },
            },
            paginationCursor: {
                page: this.$route.query.page ? parseInt(this.$route.query.page) : 1,
                perPage: this.$route.query.perPage ? parseInt(this.$route.query.perPage) : 10,
                total: 0,
            },
            selectedFavFilter: visitorStorage.selectedFavFilter,
            selectedChannel: null,
            tableLoadingInstance: null,
            visitorDownloding: false,
            saveAsCustomerGroupModalVisible: false,
            customerGroupName: "",
        };
    },
    computed: {
        ...mapState({
            onlyAdminsShowsNoOwnerContacts: (state) => state.setting.settings.onlyAdminsShowsNoOwnerContacts,
            visitorAttributes: (state) => state.contactProperty.data,
            tags: (state) => state.tag.tags.data,
            hashTags: (state) =>
                state.tag.tags.data.reduce((acc, tag) => {
                    acc[tag._id] = tag;
                    return acc;
                }, {}),
            users: (state) => state.user.users.data,
            segments: (state) => state.CB.segments,
            favFilters: (state) => state.favFilters.filters,
            maskSensitiveInfo: (state) => state.setting.settings.maskSensitiveInfo,
            isRoot: (state) => _.get(state, "auth.user.role.isRoot", false),
        }),
        ...mapGetters({
            checkPermission: "auth/checkPermission",
        }),
        visitorDetailPermission() {
            return [
                PERMISSION_TYPES["visitor.delete"].tr.name,
                PERMISSION_TYPES["visitor.update"].tr.name,
                PERMISSION_TYPES["visitor.block"].tr.name,
                PERMISSION_TYPES["visitor.unblock"].tr.name,
            ].some((permission) => this.checkPermission(permission));
        },
        tableColumns() {
            if (this.pickerMode) {
                const selectColumn = {
                    title: "Select",
                    field: "_select",
                    key: "_select",
                    width: 100,
                    align: "center",
                    fixed: "left",
                    renderBodyCell: ({ row }) => {
                        return (
                            <a-button type="primary" size="small" onClick={() => this.$emit("select", row)}>
                                Select
                            </a-button>
                        );
                    },
                };
                return [selectColumn, ...this.columns];
            }
            return this.columns;
        },
    },
    methods: {
        ...mapActions({
            getVisitorList: "visitor/getVisitorList",
            downloadVisitorList: "visitor/downloadVisitorList",
            setVisitorDetailPopup: "app/setVisitorDetailPopup",
            createFilter: "favFilters/createFilter",
            fetchFilters: "favFilters/fetchFilters",
            getFavFilters: "favFilters/getFilters",
            updateFilter: "favFilters/updateFilter",
            favFilterDelete: "favFilters/deleteFilter",
            addNewWindow: "app/addNewWindow",
        }),
        getSelectedFilters() {
            return this.filteredItems.map((filter) => {
                return {
                    key: filter.key,
                    rule: filter.rule,
                    input: filter.input,
                    value: filter.value,
                };
            });
        },
        paginationCursorChanged(cursor) {
            this.paginationCursor = _.cloneDeep(cursor);
            this.getVisitors();
        },
        formatDate(date) {
            return this.$moment(date).format("LLL");
        },
        selectFavFilter(filter, force = false) {
            this.selectedFavFilter = force ? filter : filter._id !== this.selectedFavFilter?._id && filter;
            const filters = getOrUpdateFilters(visitorStorageId);
            this.filteredItems = _.cloneDeep(this.selectedFavFilter?.filters || filters.filters || this.filteredItems);
        },
        saveFilter(name, item) {
            let isEqualName = false;
            if (!item) {
                item = (this.favFilters["page.contact-list"] || []).find((i) => i.name === name);
                isEqualName = true;
            }
            if (item) {
                this.updateFilter({
                    id: item._id,
                    key: "page.contact-list",
                    name,
                    filters: isEqualName ? this.getSelectedFilters() : item.filters,
                }).then((filter) => {
                    if (item._id === this.selectedFavFilter?._id || isEqualName) {
                        this.selectFavFilter(filter, true);
                    }
                });
            } else {
                this.createFilter({
                    key: "page.contact-list",
                    name,
                    filters: this.getSelectedFilters(),
                }).then((createdItem) => {
                    this.selectFavFilter(createdItem);
                });
            }
        },
        deleteFavFilter(key, id) {
            if (id === this.selectedFavFilter?._id) {
                this.selectFavFilter(this.selectedFavFilter);
            }
            this.favFilterDelete({ key, id });
        },
        deleteFilter(index) {
            this.filteredItems = this.filteredItems.filter((filter, i) => i !== index);
        },
        onChangeCol(col, e) {
            if (e.target.checked) {
                this.columns = [...this.columns, col];
            } else {
                this.columns = this.columns.filter((c) => c.key !== col.key);
            }
            localStorage.setItem("contacts-columns", JSON.stringify(this.columns));
        },
        syncColumns() {
            const columns = JSON.parse(
                localStorage.getItem("contacts-columns") || JSON.stringify(this.staticColumns.slice(0, 5))
            );

            const columnsHash = columns.reduce((acc, column) => {
                acc[column.key] = true;
                return acc;
            }, {});

            this.allColumns = [
                ...this.staticColumns.map((col) => ({
                    ...col,
                    enabled: columnsHash[col.key] || false,
                    width: 200,
                    align: "left",
                })),
                ...this.$_.cloneDeep(this.visitorAttributes).map((attr) => ({
                    title: attr.label,
                    field: `contactProperty_${attr._id}`,
                    key: `contactProperty_${attr._id}`,
                    enabled: columnsHash[`contactProperty_${attr._id}`] || false,
                    width: 200,
                    align: "left",
                    renderBodyCell: ({ row }) => {
                        const val = this.getContactPropertyValue(row, attr._id);
                        return <div v-tippy={{ content: val }}>{val}</div>;
                    },
                })),
            ];
            const hashedColumns = this.allColumns.reduce((acc, col) => {
                acc[col.key] = col;
                return acc;
            }, {});

            this.columns = columns.map((col) => hashedColumns[col.key]);
        },
        clearFilters() {
            this.filteredItems = [];
        },
        syncFilters() {
            const findPropertyFilter = this.filters.findIndex((f) => f.key === "contact_properties");
            const propertyFilter = {
                type: "contact-property-selector",
                name: this.$t("message.contactProperties"),
                material_icons: "alternate_email",
                multiple: true,
                key: "contact_properties",
                operators: true,
                optionSelect: true,
                options: this.visitorAttributes.map((attr) => ({
                    key: attr._id,
                    value: attr.label,
                    type: attr.type,
                })),
            };
            if (findPropertyFilter < 0) {
                this.filters = [...this.filters, propertyFilter];
            } else {
                this.filters.splice(findPropertyFilter, 1, propertyFilter);
            }

            const findTagFilter = this.filters.findIndex((f) => f.key === "tags");
            const tagFilter = {
                type: "select",
                name: this.$t("visitor.tags"),
                material_icons: "label",
                multiple: true,
                key: "tags",
                operators: true,
                defaultValue: [],
                omitOperators: [
                    "starts_with",
                    "ends_with",
                    "less_than",
                    "less_or_equal",
                    "greater_than",
                    "greater_or_equal",
                ],
                options: this.tags.map((tag) => ({
                    key: tag._id,
                    value: tag.name,
                })),
            };
            if (findTagFilter < 0) {
                this.filters = [...this.filters, tagFilter];
            } else {
                this.filters.splice(findTagFilter, 1, tagFilter);
            }

            const fUserFilter = this.filters.findIndex((f) => f.key === "preferredAgents");
            const userFilter = {
                type: "select",
                name: this.$t("message.prefferedAgents"),
                material_icons: "support_agent",
                multiple: true,
                key: "preferredAgents",
                operators: true,
                omitOperators: [
                    "starts_with",
                    "ends_with",
                    "less_than",
                    "less_or_equal",
                    "greater_than",
                    "greater_or_equal",
                ],
                options: this.users.map((user) => ({
                    key: user._id,
                    value: user.name,
                })),
            };
            if (fUserFilter < 0) {
                this.filters = [...this.filters, userFilter];
            } else {
                this.filters.splice(fUserFilter, 1, userFilter);
            }

            const fOwnerFilter = this.filters.findIndex((f) => f.key === "owner");
            let ownerOptions = [
                {
                    key: "unowned",
                    value: "Sahipsiz",
                },
                ...this.users.map((user) => ({
                    key: user._id,
                    value: user.name,
                })),
            ];
            if (!this.isRoot) {
                const onlyAdminsShowsNoOwnerContacts = this.onlyAdminsShowsNoOwnerContacts;
                if (onlyAdminsShowsNoOwnerContacts) {
                    ownerOptions = ownerOptions.filter((user) => user.key !== "unowned");
                }

                ownerOptions = ownerOptions.filter((option) =>
                    ["unowned", this.$store.state.auth.user._id].includes(option.key)
                );
            }

            const ownerFilter = {
                type: "select",
                name: "Sahiplik",
                material_icons: "assignment_ind",
                multiple: true,
                key: "owner",
                operators: true,
                omitOperators: [
                    "starts_with",
                    "ends_with",
                    "less_than",
                    "less_or_equal",
                    "greater_than",
                    "greater_or_equal",
                ],
                options: ownerOptions,
            };
            if (fOwnerFilter < 0) {
                this.filters = [...this.filters, ownerFilter];
            } else {
                this.filters.splice(fOwnerFilter, 1, ownerFilter);
            }

            const fSegmentFilter = this.filters.findIndex((f) => f.key === "segment");
            const segmentFilter = {
                type: "select",
                name: this.$t("visitor.segments"),
                material_icons: "groups",
                multiple: true,
                key: "segment",
                operators: true,
                omitOperators: [
                    "starts_with",
                    "ends_with",
                    "less_than",
                    "less_or_equal",
                    "greater_than",
                    "greater_or_equal",
                ],
                options: this.segments.map((user) => ({
                    key: user._id,
                    value: user.name,
                })),
            };
            if (fSegmentFilter < 0) {
                this.filters = [...this.filters, segmentFilter];
            } else {
                this.filters.splice(fSegmentFilter, 1, segmentFilter);
            }
        },
        getContactPropertyValue(visitor, cpId) {
            return visitor.contactProperties?.find((c) => c.property === cpId)?.value || "N/A";
        },
        paddingReset() {
            this.paddingReseted = !this.paddingReseted;
        },
        onSearch: _.debounce(function () {
            this.paginationCursor.page = 1;
            this.getVisitors();
        }, 500),
        isMaskContactInfo,
        isShouldMask(visitor, val) {
            return (
                !this.isRoot &&
                this.maskSensitiveInfo &&
                (val === visitor.email || val === visitor.whatsappNumber || val === visitor.phone)
            );
        },
        maskContactInfo(visitor, key, length = 4) {
            return this.isMaskContactInfo(key)
                ? maskContactInfo(visitor[key], length)
                : this.isShouldMask(visitor, visitor[key])
                ? maskContactInfo(visitor[key], length)
                : visitor[key];
        },
        getVisitors() {
            this.tableLoadingInstance.show();
            const filters = this.getSelectedFilters();
            getOrUpdateFilters(visitorStorageId, {
                filters,
                selectedFavFilter: this.selectedFavFilter,
                query: this.searchText,
            });
            this.$router.replace({
                query: {
                    ...this.$route.query,
                    page: this.paginationCursor.page,
                    perPage: this.paginationCursor.perPage,
                },
            });
            this.getVisitorList({
                filters,
                page: this.paginationCursor.page,
                pageSize: this.paginationCursor.perPage,
                query: this.searchText,
            }).then((response) => {
                this.tableLoadingInstance.close();
                this.paginationCursor.total = response.data.total;
                this.visitors = response.data.visitors.map((visitor) => {
                    return {
                        ...visitor,
                        fullname: this.maskContactInfo(visitor, "fullname"),
                        email: this.maskContactInfo(visitor, "email"),
                        phone: this.maskContactInfo(visitor, "phone"),
                        whatsappNumber: this.maskContactInfo(visitor, "whatsappNumber"),
                    };
                });
            });
        },
        exportToCSV() {
            const data = this.visitors.map((visitor) => {
                return this.columns.reduce((acc, column) => {
                    let value = visitor[column.key];
                    if (column.key === "tags") {
                        const names = visitor.tags.map((tag) =>
                            this.hashTags[tag] ? this.hashTags[tag].name : "Bilinmeyen"
                        );
                        value = names.join(",");
                    } else if (column.key === "connectionTime") {
                        value = this.formatDate(this.connectionTime);
                    } else if (column.key === "createdAt") {
                        value = this.formatDate(this.createdAt);
                    } else if (column.key === "_id") {
                        value = this.formatDate(this.connectionTime);
                    } else if (column.key.startsWith("contactProperty_")) {
                        value = this.getContactPropertyValue(visitor, column.key.split("_")[1]);
                    }
                    acc[column.title] = value;
                    return acc;
                }, {});
            });
            exportToCSV(data, `Supsis Contact List (${this.$moment().format("YYYY-MM-DD HH:MM")})`);
        },
        downloadAll() {
            if (this.visitorDownloding) return;
            this.visitorDownloding = true;
            this.downloadVisitorList({
                filters: this.getSelectedFilters(),
                query: this.searchText,
                download: true,
            }).then((response) => {
                this.visitorDownloding = false;
                const { s3Key } = response.data;
                const url = `https://static.supsis.live/${s3Key}`;
                window.open(url, "_blank");
            });
        },
        showSaveAsCustomerGroupModal(type) {
            this.saveAsCustomerGroupModalVisible = type;
        },
        async saveAsCustomerGroup() {
            const query = this.searchText;
            const groupName = this.customerGroupName;

            try {
                await WHATSAPP_API.BROADCAST.saveAsWhatsappCustomerGroup(
                    this.siteId,
                    this.getSelectedFilters(),
                    query,
                    groupName
                );
                this.$message.success("Whatsapp müşteri grubu başarıyla oluşturuldu.");
            } catch (error) {
                this.$message.error("Whatsapp müşteri grubu oluşturulurken bir hata oluştu.");
            }

            this.saveAsCustomerGroupModalVisible = null;
            this.customerGroupName = "";
        },
        closeCustomerGroupModal() {
            this.saveAsCustomerGroupModalVisible = null;
            this.customerGroupName = "";
        },
        async saveAsEmailCustomerGroup() {
            const query = this.searchText;
            const groupName = this.customerGroupName;
            try {
                await MAIL_API.BROADCAST.saveAsEmailCustomerGroup(
                    this.siteId,
                    this.getSelectedFilters(),
                    query,
                    groupName
                );
                this.$message.success("Mail müşteri grubu başarıyla oluşturuldu.");
            } catch (error) {
                console.error(error);
                this.$message.error("Mail müşteri grubu oluşturulurken bir hata oluştu.");
            }

            this.saveAsCustomerGroupModalVisible = null;
            this.customerGroupName = "";
        },
        async saveCustomerGroup() {
            if (this.saveAsCustomerGroupModalVisible === "whatsapp") {
                this.saveAsCustomerGroup();
            } else {
                this.saveAsEmailCustomerGroup();
            }
        },
    },
    async mounted() {
        this.tableLoadingInstance = this.$veLoading({
            target: document.querySelector("#supsis-contacts-list"),
            name: "wave",
        });
        this.syncFilters();
        this.syncColumns();
        this.getVisitors();
        this.fetchFilters("page.contact-list");
    },
    watch: {
        visitorAttributes: {
            handler() {
                this.syncColumns();
                this.syncFilters();
            },
            deep: true,
        },
        tags: {
            handler() {
                this.syncFilters();
            },
            deep: true,
        },
        users: {
            handler() {
                this.syncFilters();
            },
            deep: true,
        },
        segments: {
            handler() {
                this.syncFilters();
            },
            deep: true,
        },
        filteredItems: {
            handler() {
                if (this.filterTimeout) clearTimeout(this.filterTimeout);
                this.filterTimeout = setTimeout(() => {
                    const selectedFilters = StringUtils.hashCodeObj({ ...this.getSelectedFilters() });
                    const selectedFavFilters = StringUtils.hashCodeObj({ ...this.selectedFavFilter?.filters });
                    if (this.selectedFavFilter && selectedFilters !== selectedFavFilters) {
                        this.selectedFavFilter = null;
                    }
                    this.paginationCursor.page = 1;
                    this.getVisitors();
                }, 500);
            },
            deep: true,
        },
    },
};
</script>

<style lang="scss">
.visitor-page {
    display: flex;
    flex-direction: column;

    &-head {
        display: flex;
        align-items: center;
        gap: 5px;
        width: 100%;
        min-height: 60px;
        height: 60px;
        max-height: 60px;
        border-bottom: 1px solid var(--color-border-default);
        padding: 10px;
    }

    #banned-visitors {
        padding: 10px;
    }
}

.notting-here {
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
        width: 200px;
    }
}

.download-popover {
    .download-options {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 5px;

        .export-csv-visitor-page {
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            gap: 5px;

            &.disabled {
                cursor: not-allowed;
            }
        }
    }
}

#visitors {
    position: relative;
    height: 100%;
    display: flex;
    max-width: calc(100vw - 75px);

    #supsis-contacts-list {
        .ve-loading-wave-rect {
            background: #22272d !important;
        }
    }

    .visitor-table {
        .ve-table-header-tr,
        .ve-table-body-tr,
        .ve-table-header-th,
        .ve-table-body-td div {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            height: min-content;
        }

        &.paddingReseted {
            .ve-table-header-tr,
            .ve-table-body-tr {
                height: 0;
            }

            .ve-table-header-th,
            .ve-table-body-td {
                padding: 0;
            }
        }
    }

    .visitor-pagination {
        margin-top: 5px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }

    .flex-center-center {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .padding-zero {
        th,
        td {
            padding: 0;
        }
    }

    .limited-row td {
        max-width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-transform: ellipsis;
        text-overflow: ellipsis;
    }

    .filter-sidebar {
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        justify-content: space-between;
        width: 280px;
        max-width: 280px;
        border-right: 1px solid var(--color-border-default);
        position: relative;
        transition: all 0.3s;
        white-space: nowrap;
        font-family: Poppins;

        .filter-sidebar-content {
            display: flex;
            align-items: flex-start;
            flex-direction: column;
            gap: 4px;
            width: 280px;

            .filter-sidebar-group {
                border-bottom: 1px solid var(--color-border-default);
                width: 100%;
                padding: 10px;
                display: flex;
                align-items: flex-start;
                flex-direction: column;
                gap: 6px;

                .filter-sidebar-group-title {
                    font-weight: 600;
                    font-size: 14px;
                }

                .filter-sidebar-group-content {
                    width: 100%;

                    .favorite-items {
                        display: flex;
                        align-items: center;
                        flex-direction: column;
                        gap: 4px;
                        width: 100%;

                        .favorite-item {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            gap: 3px;
                            width: 100%;
                            padding: 5px;
                            border-radius: 4px;
                            cursor: pointer;

                            &.selected {
                                background-color: #22272d;
                                color: var(--color-text-onprimary-default);
                            }

                            &:not(&.selected) {
                                &:hover {
                                    background: var(--color-bg-neutral-hover);
                                }
                            }

                            .favorite-item-content {
                                display: flex;
                                align-items: center;
                                gap: 8px;
                                width: 100%;

                                .favorite-item-icon {
                                    &.material-icons {
                                        font-size: 18px;
                                    }

                                    .whatsapp-icon path {
                                        fill: #0bba18;
                                    }
                                }

                                .favorite-item-text {
                                    font-size: 12px;
                                    font-weight: 600;
                                    overflow: hidden;
                                    white-space: nowrap;
                                    text-overflow: ellipsis;
                                }
                            }

                            &:hover {
                                .favorite-item-edit {
                                    opacity: 1;
                                }
                            }

                            .favorite-item-edit {
                                border: 1px solid var(--color-border-default);
                                background: white;
                                color: black;
                                font-size: 18px;
                                font-weight: 400;
                                opacity: 0;
                                border-radius: 3px;
                                cursor: pointer;
                            }
                        }
                    }
                }
            }
        }

        .filter-sidebar-footer {
            display: flex;
            align-items: flex-start;
            flex-direction: column;
            gap: 4px;
            width: 100%;

            .filter-sidebar-control {
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 5px;
                border-top: 1px solid var(--color-border-default);
                width: 100%;
                padding: 10px;

                .control-button {
                    width: 100%;
                    border: 1px solid var(--color-border-default);
                    color: var(--default-text-color);
                    padding: 5px 10px;
                    border-radius: 4px;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 4px;
                    font-size: 14px;
                    user-select: none;

                    .material-icons {
                        font-size: 16px;
                    }
                }
            }

            .filter-sidebar-collapse {
                border-top: 1px solid var(--color-border-default);
                color: var(--default-text-color);
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 100%;
                cursor: pointer;
                user-select: none;
                height: 40px;
                padding: 0 10px;
            }
        }

        &.closed {
            width: 50px !important;

            .filter-sidebar-content {
                width: 100% !important;
            }

            .filter-sidebar-collapse {
                justify-content: center !important;
            }

            .favorite-item.channel-type,
            .filter-sidebar-collapse > .information-text,
            .favorite-item-text,
            .favorite-item-edit,
            .filter-sidebar-control,
            .filter-sidebar-group-title,
            .filter-sidebar-group.group-filters {
                display: none !important;
            }
        }
    }

    .visitors-content {
        width: 100%;
        min-width: calc(100% - 280px);
        padding: 30px;
        overflow-y: auto;
        height: calc(100vh - 117px);
        overflow-x: hidden;

        .save-filter-bar {
            display: flex;
            align-items: center;
            font-size: 16px;
            font-weight: 600;
            cursor: pointer;
            gap: 5px;
            white-space: nowrap;
            width: 200px;

            .filter-title {
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
        }

        .tool-head {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 20px;

            .left-side {
                width: 50%;
                display: flex;
                align-items: center;
                gap: 10px;
            }

            .right-side {
                display: flex;
                align-items: center;
                gap: 4px;
            }
        }

        .filter-name {
            display: flex;
            align-items: center;
            font-weight: bold;
            font-size: 18px;

            &.active {
                span.material-icons {
                    color: goldenrod;
                }
            }

            span.material-icons {
                margin-left: 5px;
            }
        }
    }
}

.custom-alert {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px;
    border-radius: 4px;
    background-color: #e6f7ff;
    margin-bottom: 20px;

    .custom-alert-icon {
        font-size: 24px;
        color: #1890ff;
    }

    .custom-alert-content {
        ul {
            margin: 0;
            padding-left: 20px;
        }
    }
}
</style>
